import { LoadablePaint } from '@confluence/loadable';

export const ConfluenceRecapModalLoadable = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ConfluenceRecapModal" */ './ConfluenceRecapModal.tsx'))
			.ConfluenceRecapModalErrorBoundary,
});
